import { useEffect, useState } from 'react'
import { roleValidationForm } from '../../utils/validationSchema';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import Form from '../../layouts/Form';
import RoleForm from './RoleForm';

const UpdateRole = (props: any) => {
  const { handleEdit, isLoading, data, userPermissions, logesticPermissions } = props;
  const [selectedPermission, setSelectedPermission] = useState([])
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(roleValidationForm),
    defaultValues: async () => {
      console.log(data)
      setSelectedPermission(data?.custom_permissions?[...data?.custom_permissions]:[])
      return {
        role: data?.group_name
      }
    }
  });

  useEffect(() => {
    setValue("custom_permissions", selectedPermission)
  }, [selectedPermission])

  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <RoleForm
        selectedUserPermissions={selectedPermission}
        userPermissions={userPermissions}
        logesticPermissions={logesticPermissions}
        errors={errors}
        register={register}
        setSelectedPermission={setSelectedPermission}
      />
    </Form>
  );
}

export default UpdateRole